import React, { useEffect } from 'react'
import Footer from '@/components/Footer'
import logoPath from '@/assets/logoWhite.png'
import LoginForm from './form'
import useLocale from '@/hooks/useLocale'
import locale from './locale'
import styles from './style/index.module.less'

export default function Login(): any {
  const t = useLocale(locale)

  const focusTags = [
    t['login.banner.tag.1'],
    t['login.banner.tag.2'],
    t['login.banner.tag.3'],
    t['login.banner.tag.4'],
  ]

  const capabilityList = [
    t['login.banner.capability.1'],
    t['login.banner.capability.2'],
    t['login.banner.capability.3'],
  ]

  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light')
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src={logoPath} style={{ height: '50px' }} />
      </div>
      <div className={styles.banner}>
        <div className={styles['banner-inner']}>
          <h1 className={styles['banner-title']}>{t['login.banner.title']}</h1>
          <p className={styles['banner-desc']}>{t['login.banner.desc']}</p>
          <div className={styles['banner-tag-list']}>
            {focusTags.map((tag) => (
              <span key={tag} className={styles['banner-tag']}>
                {tag}
              </span>
            ))}
          </div>
          <ul className={styles['banner-capability-list']}>
            {capabilityList.map((item) => (
              <li key={item} className={styles['banner-capability-item']}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-inner']}>
          <LoginForm />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
      </div>
    </div>
  )
}
